export default "__VITE_ASSET__98294c32__"